module.exports = __webpack_public_path__ + "media/images/sp/special_plans/icon_leaf-4272cc0b1669b10bff74faf454513fb2.png";